interface CTASectionProps {
  onOpenModal: () => void;
}

export default function CTASection({ onOpenModal }: CTASectionProps) {
  return (
    <section id="cta" className="relative py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=beautiful%20perfect%20bright%20white%20smile%20teeth%20dental%20cosmetic%20treatment%20result%20professional%20clean%20white%20and%20blue%20background%20luxury%20dental%20care%20transformative%20result%20elegant%20medical&width=1920&height=700&seq=mfdentalcta001&orientation=landscape"
          alt="Transforma tu sonrisa"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A2540]/95 via-[#0A2540]/80 to-[#0A2540]/60" />
      </div>

      {/* Decorative circles */}
      <div className="absolute -left-20 top-1/2 -translate-y-1/2 w-80 h-80 border border-[#3A86FF]/20 rounded-full" />
      <div className="absolute -left-10 top-1/2 -translate-y-1/2 w-60 h-60 border border-[#3A86FF]/15 rounded-full" />

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <div className="scroll-animate">
          {/* Pre-title */}
          <span className="inline-flex items-center gap-2 text-[#3A86FF] font-semibold text-sm tracking-widest uppercase mb-5">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-sparkling-2-line" />
            </div>
            Tu mejor versión te espera
          </span>

          {/* Main title */}
          <h2 className="text-5xl md:text-6xl font-extrabold text-white mb-6 leading-tight">
            Tu sonrisa merece{' '}
            <span className="bg-gradient-to-r from-[#3A86FF] to-[#6aa3ff] bg-clip-text text-transparent">
              lo mejor
            </span>
          </h2>

          {/* Subtitle */}
          <p className="text-white/70 text-xl max-w-2xl mx-auto leading-relaxed mb-12 font-light">
            Da el primer paso hacia la sonrisa que siempre quisiste. Nuestro equipo de especialistas en 
            rehabilitación dental en Ciudad de México está listo para ayudarte.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap items-center justify-center gap-4 mb-12">
            <button
              onClick={onOpenModal}
              className="flex items-center gap-3 bg-[#3A86FF] hover:bg-[#1a6aff] text-white px-10 py-5 rounded-full text-lg font-bold transition-all duration-300 whitespace-nowrap cursor-pointer hover:-translate-y-1 shadow-[0_10px_40px_rgba(58,134,255,0.45)]"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-calendar-check-2-line text-xl" />
              </div>
              Agenda tu cita ahora
            </button>
            <a
              href="https://wa.me/525534748982?text=Hola,%20me%20gustaría%20agendar%20una%20cita%20en%20MF%20Dental"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 bg-white/10 backdrop-blur-sm border border-white/25 hover:bg-white/20 text-white px-10 py-5 rounded-full text-lg font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer hover:-translate-y-1"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-whatsapp-line text-xl" />
              </div>
              WhatsApp
            </a>
          </div>

          {/* Trust badges */}
          <div className="flex flex-wrap items-center justify-center gap-8 text-white/50 text-sm">
            {[
              { icon: 'ri-check-double-line', text: 'Consulta inicial sin costo' },
              { icon: 'ri-shield-check-line', text: 'Especialistas certificados' },
              { icon: 'ri-time-line', text: 'Abierto hasta las 8 p.m.' },
            ].map((badge) => (
              <div key={badge.text} className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center text-[#3A86FF]">
                  <i className={badge.icon} />
                </div>
                <span>{badge.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
